/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RefreshButton from './ui/RefreshButton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Switch } from './ui/switch';
import {
  Coins, Package, Gift, Clock, Zap, Users, TrendingUp, TrendingDown,
  Plus, Edit, Trash2, Eye, Search, Filter, Download, RefreshCw,
  UserPlus, Cake, Award, ShoppingCart, FileText, Key, AlertTriangle,
  CheckCircle, XCircle, Calendar, Timer, Percent, Hash, ArrowUpRight,
  ArrowDownRight, BarChart3, PieChart, Activity, Settings, Star, CreditCard,
  HelpCircle, BookOpen
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import StripeCheckoutButton from './StripeCheckoutButton';
import Sparkline from './credits/Sparkline';
import CreditUsagePlansTab from './CreditUsagePlansTab';
import CreditStatsAdvancedTab from './CreditStatsAdvancedTab';
import CreditAlertsAdminTab from './CreditAlertsAdminTab';


export const GCBonusModal = ({ ctx }) => {
  const {
    actions, activeTab, attributeForm, attributeSearch, bonusForm, bonusRules,
    bulkAttributeForm, creditTypes, duplicateRaison, duplicateSource, duplicateTargetSearch,
    duplicateTargetUserId, editForm, editTarget, editingBonus, editingPack, loading,
    packForm, packs, searchTerm, selectedUserIds, showAttributeModal, showBonusModal,
    showBulkAttributeModal, showDuplicateModal, showEditModal, showPackModal, sparkSeries, stats,
    transactions, userBalances,
    setActions, setActiveTab, setAttributeForm, setAttributeSearch, setBonusForm, setBonusRules,
    setBulkAttributeForm, setCreditTypes, setDuplicateRaison, setDuplicateSource, setDuplicateTargetSearch,
    setDuplicateTargetUserId, setEditForm, setEditTarget, setEditingBonus, setEditingPack,
    setLoading, setPackForm, setPacks, setSearchTerm, setSelectedUserIds, setShowAttributeModal,
    setShowBonusModal, setShowBulkAttributeModal, setShowDuplicateModal, setShowEditModal, setShowPackModal,
    setSparkSeries, setStats, setTransactions, setUserBalances,
    exportUsersCsv, filteredUsers, handleAttributeCredits, handleBulkAttribute, handleBulkDelete,
    handleConfirmDuplicate, handleDeletePack, handleDeleteUserCredits, handleExportFiltered,
    handleExportSelection, handleSaveBonus, handleSaveEdit, handleSavePack, loadData, openDuplicateModal,
    openEditModal, renderIcon, resetPackForm, toggleSelectAllFiltered, toggleUserSelection,
    getAuthHeader, CountdownWidget, StatsCard, COLORS, AVAILABLE_ICONS,
  } = ctx;
  return (
      <Dialog open={showBonusModal} onOpenChange={setShowBonusModal}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Gift className="w-5 h-5 text-green-500" />
              {editingBonus ? 'Modifier la règle' : 'Nouvelle règle de bonus'}
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Code unique *</Label>
              <Input
                value={bonusForm.code}
                onChange={(e) => setBonusForm({...bonusForm, code: e.target.value.toUpperCase()})}
                placeholder="Ex: PARRAINAGE"
              />
            </div>
            
            <div>
              <Label>Nom *</Label>
              <Input
                value={bonusForm.nom}
                onChange={(e) => setBonusForm({...bonusForm, nom: e.target.value})}
                placeholder="Ex: Bonus Parrainage"
              />
            </div>

            <div>
              <Label>Description</Label>
              <Textarea
                value={bonusForm.description}
                onChange={(e) => setBonusForm({...bonusForm, description: e.target.value})}
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Crédits bonus *</Label>
                <Input
                  type="number"
                  min="1"
                  value={bonusForm.credits_bonus}
                  onChange={(e) => setBonusForm({...bonusForm, credits_bonus: parseInt(e.target.value) || 0})}
                />
              </div>

              <div>
                <Label>Validité (jours)</Label>
                <Input
                  type="number"
                  min="0"
                  value={bonusForm.duree_validite_jours || ''}
                  onChange={(e) => setBonusForm({...bonusForm, duree_validite_jours: parseInt(e.target.value) || null})}
                  placeholder="Illimité"
                />
              </div>
            </div>

            <div>
              <Label>Type de déclencheur</Label>
              <Select value={bonusForm.type_declencheur} onValueChange={(v) => setBonusForm({...bonusForm, type_declencheur: v})}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="EVENT">Événement (inscription, achat...)</SelectItem>
                  <SelectItem value="DATE">Date (anniversaire...)</SelectItem>
                  <SelectItem value="SEUIL">Seuil (cumul achats...)</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowBonusModal(false)}>Annuler</Button>
            <Button onClick={handleSaveBonus} className="bg-green-600 hover:bg-green-700">
              {editingBonus ? 'Mettre à jour' : 'Créer la règle'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default GCBonusModal;
